export const DISTANCE_CONVERSION = 112370.0227;

export function metersToDegrees(meters) {
  return meters / DISTANCE_CONVERSION;
}

export function degreesToMeters(degrees) {
  return degrees * DISTANCE_CONVERSION;
}
